import { Action, ActionReducer, ActionReducerMap, createSelector } from '@ngrx/store';

import * as Sentry from '@sentry/browser';
import { Injectable, InjectionToken } from '@angular/core';
import { IEntitiesState, entitiesReducer } from './entities/entity.reducer';
import { UIState, uiReducer } from './ui/ui.reducer';
import * as fromAuth from '../auth/auth.reducer';
import { routerReducer } from '@ngrx/router-store';
import {
  AppConfig,
  AppConfigService,
} from '../services/config/app-config.service';
import { configReducer } from '@core/state/config/config.reducer';
import { Params } from '@angular/router';
import {
  GlobalRequestState,
  globalRequestStateReducer,
} from '@core/state/global-request-state/global-request-state.reducer';
import { projectDetailActions } from '@core/actions/project-detail.actions';
import { metadataReducer, metadataState } from '@core/state/metadata/metadata.reducer';
import { EnvironmentState, environmentReducer, ENVIRONMENT_FEATURE_KEY } from '@core/state/environment';

export interface RouterStateUrl {
  url: string;
  params: Params;
  queryParams: Params;
}



export interface IAppState {
  auth: fromAuth.State;
  entities: IEntitiesState;
  ui: UIState;
  router: { state: RouterStateUrl };
  config: AppConfig;
  globalRequestState: GlobalRequestState;
  metadata: metadataState;
  [ENVIRONMENT_FEATURE_KEY]: EnvironmentState;
}

export interface IAction {
  type: string;
  payload?: any;
  miniPayload?: any;
}

export const reducers = {
  auth: fromAuth.authReducer,
  entities: entitiesReducer,
  router: routerReducer,
  ui: uiReducer,
  config: configReducer,
  globalRequestState: globalRequestStateReducer,
  metadata: metadataReducer,
  [ENVIRONMENT_FEATURE_KEY]: environmentReducer,
};
export const metaReducers = [sentryLogger, stateSetter];

export function sentryLogger(
  reducer: ActionReducer<IAppState>,
): ActionReducer<IAppState> {
  return function(state, action: IAction) {
    if (AppConfigService.staticConfig.errorTracking) {
      const data = action.miniPayload
        ? { type: action.type, miniPayload: action.miniPayload }
        : action;
      Sentry.addBreadcrumb({
        category: 'action',
        data,
        message: action.type,
        level: 'log' as Sentry.SeverityLevel,
      });
    }
    return reducer(state, action);
  };
}

export function stateSetter(
  reducer: ActionReducer<IAppState>,
): ActionReducer<IAppState> {
  return function(state, action: { type: string; payload?: any }) {
    if (action.type === 'SET_ROOT_STATE') {
      return action.payload;
    }
    return reducer(state, action);
  };
}

export const reducerToken = new InjectionToken<ActionReducerMap<IAppState>>(
  'Reducers',
);

export function getReducers() {
  return reducers;
}

export const reducerProvider = [
  { provide: reducerToken, useFactory: getReducers },
];

@Injectable()
export class StateService {
  constructor() {
  }
}
